<div class="block--content block">
    <div class="block--wrap well well--collapsing container block">
        <!--<app-notification-list></app-notification-list>-->
    </div>

    <div class="block--wrap block">
        <div class="ticket">
            <div class="intro-text">
                <p class="title">
                    {{ 'TRAVELCARD_DETAIL_TITLE' | translate }}
                </p>
                <p class="remove-for-print-layout">
                    {{ 'CARD_STATUS_NOTIFICATION_BODY' | translate }}
                </p>
            </div>

            <rwidget-travelcard-tickets></rwidget-travelcard-tickets>
        </div>
    </div>
</div>
